import React from "react";
import { DashboardShell } from "@/components/DashboardShell";
import ReferralInvites from "@/components/ReferralInvites";
import { STUDENT_NAV } from "@/lib/studentNav";

export default function Referrals() {
  return (
    <DashboardShell nav={STUDENT_NAV} title="Referral">
      <ReferralInvites />
    </DashboardShell>
  );
}
